const Building = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75 8.25H13.35C14.1901 8.25 14.6101 8.25 14.931 8.41349C15.2132 8.5573 15.4427 8.78677 15.5865 9.06901C15.75 9.38988 15.75 9.80992 15.75 10.65V15.75M9.75 15.75V4.65C9.75 3.80992 9.75 3.38988 9.58651 3.06901C9.4427 2.78677 9.21323 2.5573 8.93099 2.41349C8.61012 2.25 8.19008 2.25 7.35 2.25H4.65C3.80992 2.25 3.38988 2.25 3.06901 2.41349C2.78677 2.5573 2.5573 2.78677 2.41349 3.06901C2.25 3.38988 2.25 3.80992 2.25 4.65V15.75M16.5 15.75H1.5M4.875 5.25H7.125M4.875 8.25H7.125M4.875 11.25H7.125"
      stroke="#A4A7AE"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Building;
